
























































import Vue from "vue";
/* eslint-disable */
import {
  createComponent,
  ref,
  Ref,
  provide,
  watch,
} from "@vue/composition-api";
/* eslint-enable */

import PercentagePopulation from "@dcc/components/PercentagePopulation.vue";
import DangerousToHealthModal from "@dcc/components/DangerousToHealthModal.vue";
import DrinkRiskLevel from "@dcc/components/DrinkRiskLevel.vue";
import WeeklyConsumption from "@dcc/components/WeeklyConsumption.vue";
import ActionPlanCreator from "@dcc/components/ActionPlanCreator.vue";
import { findGetters as findProfileGetters } from "@dcc/store/profile/getters";
import { findGetters as findScoreGetters } from "@dcc/store/score/getters";
import { findGetters as findDrinkingGetters } from "@dcc/store/drinking/getters";
import { getActions } from "@dcc/store/score/actions";
import { useDrinkAlerts } from "@dcc/views/compositions/useDrinkAlerts";
import { useWeeklyUnits } from "@dcc/views/compositions/useWeeklyUnits";
import DrinkerResultsBackground from "@dcc/components/DrinkerResultsBackgrounds.vue";
import { RiskLevel } from "@dcc/types/riskLevel";
import { riskToColour, LOW_DRINKER_BINGE_COLOUR } from "@dcc/constants/riskLevels";

interface DrinkerResultsProps {
  showActionPlan: boolean;
}

export default createComponent({
  props: {
    showActionPlan: {
      type: Boolean,
      required: true
    }
  },
  components: {
    DrinkerResultsBackground,
    PercentagePopulation,
    DangerousToHealthModal,
    DrinkRiskLevel,
    WeeklyConsumption,
    ActionPlanCreator
  },
  setup(props: DrinkerResultsProps, context) {
    const drinkAlerts = useDrinkAlerts(context);
    const weeklyUnits = useWeeklyUnits(context);

    const actionPlan: Ref<HTMLElement | null> = ref(null);

    const { getGender } = findProfileGetters(context.root.$store);
    const gender = getGender();
    const { getDrinkFrequency } = findDrinkingGetters(context.root.$store);
    const drinkFrequency = getDrinkFrequency();

    const { getPercentWhoDrinkLess, getRiskLevel } = findScoreGetters(
      context.root.$store
    );
    const percentage = getPercentWhoDrinkLess();
    const riskLevel = getRiskLevel();
    const originalRiskLevel = riskLevel.value;

    const riskColourClass = drinkAlerts.isLowRiskBingeDrinker.value
      ? LOW_DRINKER_BINGE_COLOUR
      : riskToColour[riskLevel.value];

    const { saveScore, trackDFDEvent } = getActions(context.root.$store);
    saveScore();
    trackDFDEvent();

    watch(
      () => props.showActionPlan,
      show => {
        if (show) {
          Vue.nextTick(function() {
            actionPlan.value &&
              actionPlan.value.scrollIntoView({
                behavior: "smooth",
                block: "start"
              });
          });
        }
      }
    );

    provide("actionPlanRef", actionPlan);

    return {
      ...drinkAlerts,
      ...weeklyUnits,
      actionPlan,
      gender,
      drinkFrequency,
      percentage,
      riskLevel,
      originalRiskLevel,
      riskColourClass,
      RiskLevel
    };
  }
});
